import axios from 'axios'

export default {
  // ======================================================================
  // ==========================List Management=============================
  // ======================================================================
  daylockdownhubList (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/daylockdownhub', { params: opts })
        .then(({ data }) => {
          context.commit('DAYLOCKDOWNHUB_LIST', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  // ==========================Socket Updates==============================
  daylockdownhubCreated (context, opts) {
    // do nothing
  },
  daylockdownhubUpdated (context, opts) {
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    const inputs = { }
    if (opts && Array.isArray(opts.populate) && opts.populate.length > 0) {
      inputs.params = { }
      inputs.params.populate = opts.populate
    }
    const inList = context.state.list.find((i) => i.id === id)
    if (context.state.current.id === id || inList) {
      axios
        .get(`/api/daylockdownhub/${id}`, inputs)
        .then(({ data }) => {
          if (data.id === context.state.current.id) {
            context.commit('DAYLOCKDOWNHUB_CURRENT', data)
          }
          if (inList) {
            context.commit('DAYLOCKDOWNHUB_LIST_UPDATE', data)
          }
        }).catch(() => {
        })
    }
  },
  daylockdownhubUpdate (context, opts) {
    const updates = Object.assign({}, context.state.update)
    for (const key of Object.keys(updates)) {
      if (updates[key] === null) {
        delete updates[key]
      }
    }
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/daylockdownhub/${context.state.current.id}`, updates)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  daylockdownhubDestroyed (context, opts) {
    // always try to remove from list
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    if (id === context.state.current.id) {
      context.commit('DAYLOCKDOWNHUB_CURRENT', null)
    }
    context.commit('DAYLOCKDOWNHUB_LIST_ITEM_REMOVE', opts)
  },
  // ======================================================================
  // ==========================Item Management=============================
  // ======================================================================
  dayLockdownHubAcknowledgeAlarms (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/daylockdownhub/acknowledgealarms', opts)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  daylockdownhubDetail (context, opts) {
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    const inputs = { }
    if (opts && Array.isArray(opts.populate) && opts.populate.length > 0) {
      inputs.params = { }
      inputs.params.populate = opts.populate
    }
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/daylockdownhub/${id}`, inputs)
        .then(({ data }) => {
          context.commit('DAYLOCKDOWNHUB_CURRENT', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  }
}
